/**
 * @generated SignedSource<<afe6813b52f50df62f9b201fab5e0166>>
 * @relayHash fa8d1823edd0954847716726750cb751
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 425fb5abbbccbd28041eb61d9421fb80cb5556cbd7425f00078f5eb05f763d8a

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceCreatePagePropertyInput = {
  key: string;
  pageId: string;
  value: string;
};
export type useEmojiEverSetPropertyMutation$variables = {
  input: ConfluenceCreatePagePropertyInput;
};
export type useEmojiEverSetPropertyMutation$data = {
  readonly confluence: {
    readonly createPageProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useEmojiEverSetPropertyMutation = {
  response: useEmojiEverSetPropertyMutation$data;
  variables: useEmojiEverSetPropertyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ConfluenceCreatePagePropertyPayload",
        "kind": "LinkedField",
        "name": "createPageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "pageProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa8d1823edd0954847716726750cb751",
    "id": "425fb5abbbccbd28041eb61d9421fb80cb5556cbd7425f00078f5eb05f763d8a",
    "metadata": {},
    "name": "useEmojiEverSetPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation useEmojiEverSetPropertyMutation($input:ConfluenceCreatePagePropertyInput!){confluence{createPageProperty(input:$input){success,pageProperty{key,value},errors{message}}}}"
  }
};
})();

(node as any).hash = "771265924e6d3ef23e44e1c16875a2ba";

export default node;
